@for (value of values; track trackByIndex($index); let i = $index) {
  @if (label) {
    <pr-input [label]="labelFor(i)" [derrors]="derrors">
      <input
        type="text"
        [value]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        (input)="update(i, $any($event.target).value)"
      />
      @if (values.length > 1) {
        <button
          type="button"
          class="string-list-remove string-list-remove-inline"
          [disabled]="disabled"
          (click)="remove(i)"
        >
          <pr-icon name="delete_outline"></pr-icon>
        </button>
      }
    </pr-input>
  } @else {
    <div class="string-list-row">
      <pr-input [derrors]="derrors">
        <input
          type="text"
          [value]="value"
          [placeholder]="placeholder"
          [disabled]="disabled"
          (input)="update(i, $any($event.target).value)"
        />
      </pr-input>
      @if (values.length > 1) {
        <button
          type="button"
          class="string-list-remove"
          [disabled]="disabled"
          (click)="remove(i)"
        >
          <pr-icon name="delete_outline"></pr-icon>
        </button>
      }
    </div>
  }
}

<pr-button-add
  type="button"
  display="neutral"
  [class.string-list-add-indented]="!!label"
  [label]="addLabel"
  rightIcon="+"
  (click)="add()"
>
</pr-button-add>
